// extracted by mini-css-extract-plugin
module.exports = {"reportValue":"ReportValue_reportValue__1UtU5","reportLabel":"ReportValue_reportLabel__2q5Xi"};